import * as React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { getEntityById, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { EmptyState } from '../empty_state/EmptyState';
import { fetchAllWorkOrderNotesForBuyer } from '../../thunks/messages_thunks';
import MessageBubble from '../MessageBubble';
import MessageLog from '../MessageLog';
import { isNoteValid } from '../../utils/WorkOrderUtils';
import { NOTE_TYPE_LOG } from '../../constants/NoteTypes';

const { Content } = Layout;

require('./PurchaseOrderNotesPage.less');

class PurchaseOrderNotesPage extends React.Component<any, any> {
	render() {
		const { purchaseOrder, currentUser, fetching } = this.props;
		const notes = nullSafeGetOrElse(`notes`, purchaseOrder, []);
		const actualNotes = notes.filter(isNoteValid);

		return fetching ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="PurchaseOrderNotesPage">
				<div
					id="chatBox"
					style={{
						flexGrow: 1,
						overflowY: 'auto',
					}}
					className="no-scrollbar"
				>
					{actualNotes.length > 0 ? (
						<div className="chatList">
							{actualNotes.map((n, idx) => {
								return n.type === NOTE_TYPE_LOG ? (
									<MessageLog log={n} />
								) : (
									<MessageBubble
										currentUser={currentUser}
										n={n}
										idx={idx}
										subscribers={[]}
										userType="supplier"
										key={idx}
									/>
								);
							})}
						</div>
					) : (
						<EmptyState
							graphic={
								<img
									style={{ marginBottom: 8 }}
									src="https://s3.amazonaws.com/mock-data-assets/categories/images/letter owl.svg"
									alt="No notes have been added yet"
								/>
							}
							headline={'No notes have been added yet'}
						/>
					)}
				</div>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	purchaseOrder: getEntityById(ownProps.match.params.id, state.purchase_orders),
	currentUser: state.session.currentUser,
	fetching: state.purchase_orders.fetching,
});

const mapDispatchToProps = (dispatch) => ({
	fetchMessages: (workOrderId) => dispatch(fetchAllWorkOrderNotesForBuyer(workOrderId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderNotesPage));
